import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "modal-body" }
const _hoisted_2 = { class: "mb-10" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "form-label"
}, "Name", -1)
const _hoisted_4 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "modal-footer" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    id: "closeAddBiModal",
    class: "btn btn-light",
    "data-bs-dismiss": "modal"
  }, " Close "),
  /*#__PURE__*/_createElementVNode("button", {
    type: "submit",
    class: "btn btn-primary"
  }, "Save")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("form", {
    class: "form",
    onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          name: "name",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.tokenTypeName) = $event)),
          class: "form-control form-control-solid",
          id: "name"
        }, null, 512), [
          [_vModelText, _ctx.state.tokenTypeName]
        ]),
        (_ctx.v$.tokenTypeName.$error)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.v$.tokenTypeName.$errors[0].$message), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _hoisted_5
  ], 32))
}